Vue.component('ack-footer', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-footer',
  mounted() {
    appLog.log('ack-footer mounted')
    
    
    
  },
  props:{
    data: {
      type: Object,
      required: true
    }
    
  },
  computed: {
    //...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
    
  },
  data() {
    return {

    }
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
    
    
    createFormHS() {


      let formId = '40198688-96ac-4947-8a94-b93ec0bb098c'

      
      window.hbspt.forms.create({
          target: '#newsletter-suscribe-form',
          region: "na1",
          portalId: "2471334",
          formId: formId,
          onFormReady: ($form)=>{
              
              // let idEmailInput = $form.querySelector('input[name="email"]').id
              // // $form.querySelector('input[name="email"]').setAttribute('type','hidden')
              // $form.querySelector(`label[for="${idEmailInput}"]`).setAttribute('style','display:none;')
              // $form.querySelector('fieldset.form-columns-0').setAttribute('style','visibility: hidden;')
      
              let styleElement = document.createElement('style')
      
      
              styleElement.innerHTML = ' .legal-consent-container .hs-richtext p a{ color: #981d97; }  form > div.hs_submit.hs-submit > div.actions > input{ border-radius: 2rem; border-width: 3px; } form > div.hs_submit.hs-submit > div.actions > input:hover{ color: #981d97; border-color: #981d97; background-color: white; } form p *{ font-family: Arial,Verdana,sans-serif; font-size: 18px; } label,strong{ color: #702082 !important;} .inputs-list>li {display: inline-block; width: 14em;}'
      
              $form[0].appendChild(styleElement)
      
              setTimeout(()=>{
                  
                  
                  // $form.querySelector('input[name="firstname"]').value = this.userGivenName
                  // $form.querySelector('input[name="lastname"]').value = this.userFamilyName
      
                  // $form.querySelector('input[name="email"]').setAttribute('disabled','')
                  // $form[0].querySelector('input[name="email"]').setAttribute('value',this.userEmail)
                  // $form[0].querySelector('input[name="email"]').value = this.userEmail
                  // const event = new Event('change');
                  // $form[0].querySelector('input[name="email"]').dispatchEvent(event);
                  
                 
              }, 1000)
          }
      })
    },

  },
  beforeDestroy() {
    
  },
  watch: {
    
    data: {
      handler() {
        
        
        
      },
      deep: false
    }
  }
})